var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeftAlt = function SvgArrowLeftAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "arrow-left-alt_svg__svg-icon",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "arrow-left-alt_svg__arrow-left-alt"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.99 11H19c.55 0 1 .45 1 1s-.45 1-1 1H7.99v1.79c0 .45-.54.67-.85.35l-2.78-2.79a.513.513 0 0 1 0-.71l2.78-2.79c.31-.32.85-.09.85.35z",
    className: "arrow-left-alt_svg__vector"
  }))));
};
export { SvgArrowLeftAlt as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAyNCAyNCIgY2xhc3M9InN2Zy1pY29uIiByb2xlPSJpbWciPjx0aXRsZT5BcnJvdyBMZWZ0IEFsdDwvdGl0bGU+PGcgY2xhc3M9ImFycm93LWxlZnQtYWx0Ij48cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIGQ9Ik03Ljk5IDExSDE5Yy41NSAwIDEgLjQ1IDEgMXMtLjQ1IDEtMSAxSDcuOTl2MS43OWMwIC40NS0uNTQuNjctLjg1LjM1bC0yLjc4LTIuNzlhLjUxMy41MTMgMCAwIDEgMC0uNzFsMi43OC0yLjc5Yy4zMS0uMzIuODUtLjA5Ljg1LjM1VjExWiIgY2xhc3M9InZlY3RvciIvPjwvZz48L3N2Zz4=";